import React from "react";
import { Box } from "@chakra-ui/react";
import Navbar from "../components/Navbar";
import CategoryPermissions from "../components/user/CategoryPermissions";

const CategoryPermissionsPage = () => {
    return (
        <Box h="100vh" display="flex" flexDirection="column">
            <Navbar />
            <Box flex="1" zIndex={1}>
                <CategoryPermissions />
            </Box>
        </Box>
    );
};

export default CategoryPermissionsPage;